var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Button",
        {
          attrs: { type: _vm.buttonType },
          on: {
            click: function ($event) {
              _vm.modalShow = true
            },
          },
        },
        [_vm._v(_vm._s(_vm.btnShowText))]
      ),
      _c(
        "Modal",
        {
          attrs: {
            width: 550,
            height: 600,
            styles: { top: "20px" },
            title: "图片选择",
          },
          on: { "on-visible-change": _vm.onVisibleChange },
          model: {
            value: _vm.modalShow,
            callback: function ($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow",
          },
        },
        [
          _c(
            "div",
            { staticClass: "cut" },
            [
              _c(
                "ImgCutter",
                {
                  ref: "imgCutter",
                  attrs: {
                    "show-choose-btn": true,
                    "is-modal": false,
                    "box-width": 300,
                    "box-height": 300,
                    tool: false,
                  },
                  on: { cutDown: _vm.cutDown },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { slot: "open" },
                      slot: "open",
                    },
                    [_vm._v("点击选择图片")]
                  ),
                  _c("div", { attrs: { slot: "choose" }, slot: "choose" }),
                ]
              ),
            ],
            1
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }